import { useEffect, useRef } from "react";
import { createArcade } from "@/lib/arcade";
import { M } from "./Hero";

const G = [
  ["penal", "juego-penal", "⚽ Penaltis", "Toca el arco. El arquero lee tu intención."],
  ["beis", "beisbol", "⚾ Jonrón", "Toca justo cuando la bola llegue a la zona."],
  ["box", "juego-box", "🥊 Reflejos", "Golpea las amarillas. Las rojas no."],
  ["pesas", "juego-pesas", "🏋️ Levantamiento", "Toca en la zona verde para subir la barra."],
];

export const Juegos = () => {
  const modal = useRef(null), cv = useRef(null), title = useRef(null), tip = useRef(null), closeB = useRef(null), restartB = useRef(null);
  const arcade = useRef(null);

  useEffect(() => {
    arcade.current = createArcade({ modal: modal.current, cv: cv.current, titleEl: title.current, tipEl: tip.current, closeBtn: closeB.current, restartBtn: restartB.current });
    return () => arcade.current.destroy();
  }, []);

  return (
    <>
      <section id="juegos" style={{ background: "var(--navy-3)" }} data-testid="juegos-section">
        <div className="wrap">
          <div className="head reveal"><h2>Los 4 retos Once y Once</h2><p className="lead" style={{ margin: 0 }}>Juega desde tu celular o tu computador. Antes de cada reto, respira como un campeón.</p></div>
          <div className="games">
            {G.map(([id, img, h, p]) => (
              <button key={id} className="gcard" onClick={() => arcade.current.open(id)} data-testid={`game-card-${id}`}>
                <img src={M(`real/${img}.webp`)} alt="" loading="lazy" />
                <div><h3>{h}</h3><p>{p}</p><span className="go">▶ Jugar</span><span className="best" data-best={id}></span></div>
              </button>
            ))}
          </div>
        </div>
      </section>
      <div className="modal" ref={modal} role="dialog" aria-modal="true" aria-labelledby="gTitle" data-testid="game-modal">
        <div className="stage">
          <div className="bar"><h3 id="gTitle" ref={title}>Juego</h3><div className="t">
            <button className="ib" ref={restartB} aria-label="Reiniciar" data-testid="game-restart-btn"><svg width="20" height="20" viewBox="0 0 20 20"><path d="M16 10a6 6 0 1 1-2-4.5M16 3v4h-4" fill="none" stroke="#fff" strokeWidth="2.2" strokeLinecap="round" /></svg></button>
            <button className="ib" ref={closeB} aria-label="Cerrar" data-testid="game-close-btn"><svg width="18" height="18" viewBox="0 0 18 18"><path d="M3 3l12 12M15 3L3 15" stroke="#fff" strokeWidth="2.4" strokeLinecap="round" /></svg></button>
          </div></div>
          <canvas id="cv" ref={cv} data-testid="game-canvas"></canvas>
          <p className="tip" ref={tip} data-testid="game-tip"></p>
        </div>
      </div>
    </>
  );
};
